import _ from 'lodash';
import config from '~/config';
import { PayloadModalOpen } from '../actions';


/** types */
export interface IState {
  modal: IModalState;
  frame: IFrameState;
  resources: IResourcesState;
  user: IUserState | null;
  entryParams: IEntryParams;
  accessModuleDirectly: boolean;
}
export type IModalMode = 'normal' | 'fullscreen' | 'minimal';
export interface IModalState {
  show: boolean;
  content: any;
  mode: IModalMode;
}
export interface IFrameState {
  show: boolean;
  url: string;
}

export interface IUserState { // default
  // CRM
  uid: string;
  username: string; 
  email: string; 
  firstName: string; 
  lastName: string; 
  profileImageURL: string; 
  profileImageURLSmall: string;
  confirmed: boolean;
  suspended: boolean;
  
  // Strapi
  token: string;
  role: any;
  favoriteResources: [];
  userLogins: [];
  contentID: string;
}
export const IUserStateDefault: IUserState = {
  uid: '',
  username: '',
  email: '',
  firstName: '',
  lastName: '',
  profileImageURL: '',
  profileImageURLSmall: '',
  confirmed: false,
  suspended: false,
  token: '',
  role: {},
  favoriteResources: [],
  userLogins: [],
  contentID: ''
}

export interface IResourcesState {
  all: IResource[];
  favoriteResources: number[];
}
export interface IResource {
  id: number,
  type: IResourceType,
  thumbnail?: {
    url: string,
    [key: string]: any
  },
  title: string,
  description: string,
  [key: string]: any
}
export type IResourceType = 'Document' | 'Image' | 'Video' | 'Link' | 'Presentation' | 'Training';
export interface IEntryParams {
  [key: string]: string | boolean | number;
}

// Define initial state (with commented-out examples of non-empty data, e.g. from API call)
const initialState: IState = {
  modal: {
    show: false,
    content: null,
    mode: 'normal'
  },
  frame: {
    show: true,
    url: '',
  },
  resources: {
    all: [],
    favoriteResources: []
  },
  user: null,
  entryParams: {},
  accessModuleDirectly: false
};

// Define list of actions
export enum actions {
  UPDATE_USER = 'UPDATE_USER',
  CLEAR_USER = 'CLEAR_USER',

  UPDATE_USER_TOKEN = 'UPDATE_USER_TOKEN',
  CLEAR_USER_TOKEN = 'CLEAR_USER_TOKEN',

  UPDATE_RESOURCES = 'UPDATE_RESOURCES',
  CLEAR_RESOURCES = 'CLEAR_RESOURCES',
  ADD_RESOURCE_FAV = 'ADD_RESOURCE_FAV',
  REMOVE_RESOURCE_FAV = 'REMOVE_RESOURCE_FAV',
  TOGGLE_RESOURCE_FAV = 'TOGGLE_RESOURCE_FAV',
  CLEAR_RESOURCE_FAVS = 'CLEAR_RESOURCE_FAVS',

  OPEN_MODAL = 'OPEN_MODAL',
  CLOSE_MODAL = 'CLOSE_MODAL',

  UPDATE_ENTRY_PARAMS = 'UPDATE_ENTRY_PARAMS',
  CLEAR_ENTRY_PARAMS = 'CLEAR_ENTRY_PARAMS',

  UPDATE_ACCESS_MODULE_DIRECTLY = 'UPDATE_ACCESS_MODULE_DIRECTLY'
}

// Define behaviors for the actions
function rootReducer(state = initialState, action) {
  let newState;
  let payload;

  switch (action.type) {
    case actions.UPDATE_USER:
      newState = { ...state, user: action.payload };
      break;
    case actions.CLEAR_USER:
      newState = { ...state, user: null };
      break;
    case actions.UPDATE_USER_TOKEN:
      newState = { ...state, user: { ...state.user, token: action.payload} };
      break;
    case actions.CLEAR_USER_TOKEN:
      newState = { ...state, user: { ...state.user, token: ''} };
      break;

    case actions.UPDATE_RESOURCES:
      newState = { ...state, resources: { ...state.resources, all: action.payload } };
      break;
    case actions.CLEAR_RESOURCES:
      newState = { ...state, resources: { ...state.resources, all: [] } };
      break;

    case actions.ADD_RESOURCE_FAV:
      payload = action.payload as number;
      newState = { ...state, resources: { 
        ...state.resources, 
        favoriteResources: _.uniq( [...state.resources.favoriteResources, payload] )
      } };
      break;
    case actions.REMOVE_RESOURCE_FAV:
      payload = action.payload as number;
      newState = { ...state, resources: { 
        ...state.resources, 
        favoriteResources: _.pull( state.resources.favoriteResources, payload )
      } };
      break;
    case actions.TOGGLE_RESOURCE_FAV:
      // payload = action.payload as number;
      // newState = { ...state, resources: { 
      //   ...state.resources, 
      //   favoriteResources: _.includes( state.resources.favoriteResources, payload ) ? 
      //     _.pull( state.resources.favoriteResources, payload ) :
      //     [...state.resources.favoriteResources, payload]
      // } };
      newState = { ...state, user: {
        ...state.user,
        favoriteResources: action.payload
      }}
      break;
    case actions.CLEAR_RESOURCE_FAVS:
      newState = { ...state, resources: {
        ...state.resources,
        favoriteResources: []
      }}
      break;

    case actions.OPEN_MODAL:
      payload = action.payload as PayloadModalOpen;
      newState = { ...state, modal: { show: true, ...payload } };
      break;
    case actions.CLOSE_MODAL:
      newState = {
        ...state,
        modal: {
          ...state.modal,
          show: false,
          content: null // cleanup on modal close
          /* per Lukasz: content: null - we want to animate, so let's leave it */,
        },
      };
      break;
      
    case actions.UPDATE_ENTRY_PARAMS:
      newState = { ...state, entryParams: action.payload};
      break;
    case actions.CLEAR_ENTRY_PARAMS:
      newState = { ...state, entryParams: {}};
      break;
    case actions.UPDATE_ACCESS_MODULE_DIRECTLY:
      newState = { ...state, accessModuleDirectly: action.payload};
      break;
    default:
      newState = state;
  }

  if (config.debug) { console.log('updated global redux state to', newState); }

  return newState;
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.ts